import { RELAY_API_CONTENTFUL } from "@/utils/constant";

import {
    PricingPageRelayQuery,
    getPricingPageRelayQueryVars
} from "../contentful/graphql";
import { init as initRelay } from "../init-relay";
import { getPricingTitleInternal } from "../pages/software/jira/product-discovery/pricing/feature-gates";
import { JiraProductDiscoveryPricingPage } from "../pages/software/jira/product-discovery/pricing/jira-product-discovery-pricing-page";

const pricingTitleInternal = getPricingTitleInternal();

initRelay(
    JiraProductDiscoveryPricingPage,
    PricingPageRelayQuery,
    getPricingPageRelayQueryVars(
        "jira-product-discovery",
        window.location,
        pricingTitleInternal
    ),
    RELAY_API_CONTENTFUL
);
